import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { Navbar } from './components/Navbar';
import Index from './pages/LandingPage/Index';
import News from './pages/News/Index';
import About from './pages/About/Index';
import Display from './pages/News/Display';
import PrivacyPolicy from './pages/Privacy Policy/PrivacyPolicy';
import TermsAndConditions from './pages/Terms and conditions/TermsAndConditions';
import TermsOfUse from './pages/Terms of use/TermsOfUse';
import FAQ from './pages/FAQ/FAQ';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Navbar />}>
            <Route index element={<Index />} />
            <Route path='about' element={<About />} />
            <Route path='news' element={<News />} />
            <Route path='news/:id' element={<Display />} />
            <Route path='privacy-policy' element={<PrivacyPolicy />} />
            <Route path='terms-and-conditions' element={<TermsAndConditions />} />
            <Route path='terms-of-use' element={<TermsOfUse />} />
            <Route path='faq' element={<FAQ />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
